import {matchPath} from "react-router";


const noNavRoutes = ["/help-center","/admin/system-alerts", "/admin/course-management"];

const queryStringObjectFromWindowLocation = (location) => {
  const {search:querystring} = location ?? {};

  let queryParams = {};

  //some root-level routes need to keep track of the user's navigation location
  //so we route those into the querystring.
  if (querystring) {
    //remove the "?" at the beginning and split on &
    let pairs = querystring.slice(1).split("&");
    queryParams = pairs.reduce((data,pairstring) => {
      const pair = pairstring.split("=");
      return {...data, [pair[0]]:pair[1]}
    },{});
  }
  return queryParams;

}

const windowLocationToNavigationParameters = (location) => {
  const queryParams = queryStringObjectFromWindowLocation(location);
  const {pathname:path} = location ?? {}
  const noNavRoute = noNavRoutes.indexOf(path) >= 0;
  if (noNavRoute) {
    return {
      noNav:true
    }
  }
  let areaCheck = "areas/:areaId/*";
  let areaMatch = matchPath({path:areaCheck},path);
  let {areaId} = areaMatch?.params ?? {};

  let regionCheck = "areas/:areaId/regions/:regionId/*";
  let regionMatch = matchPath({path:regionCheck},path);
  let {regionId} = regionMatch?.params ?? {}
  if (isNaN(parseInt(regionId))) {
    regionId = null;
  }

  let coordinatorCheck = "areas/:areaId/regions/:regionId/coordinators/:coordinatorId/*";
  let coordinatorMatch = matchPath({path:coordinatorCheck},path);
  let {coordinatorId} = coordinatorMatch?.params ?? {};
  if (isNaN(parseInt(coordinatorId))) {
    coordinatorId = null;
  }

  let programCheck = "areas/:areaId/regions/:regionId/coordinators/:coordinatorId/programs/:programId/*";
  let programMatch = matchPath({path:programCheck},path);
  let {programId} = programMatch?.params ?? {};

  let yearCheck = "areas/:areaId/regions/:regionId/coordinators/:coordinatorId/programs/:programId/years/:yearId/*";
  let yearMatch = matchPath({path:yearCheck},path);
  let {yearId} = yearMatch?.params ?? {};

  let termCheck = "areas/:areaId/regions/:regionId/coordinators/:coordinatorId/programs/:programId/years/:yearId/terms/:termId/*";
  let termMatch = matchPath({path:termCheck},path);
  let {termId} = termMatch?.params ?? {};

  let {
    areaId:qAreaId,
    regionId:qRegionId,
    coordinatorId:qCoordinatorId,
    programId:qProgramId,
    yearId:qYearId,
    termId:qTermId
  } = queryParams ?? {};

  if (isNaN(parseInt(areaId))) {
    qAreaId = parseInt(qAreaId);
    areaId = !isNaN(qAreaId) ? qAreaId : null;
  }
  if (isNaN(parseInt(regionId))) {
    qRegionId = parseInt(qRegionId);
    regionId = !isNaN(qRegionId) ? qRegionId : null;
  }
  if (isNaN(parseInt(coordinatorId))) {
    qCoordinatorId = parseInt(qCoordinatorId);
    coordinatorId = !isNaN(qCoordinatorId) ? qCoordinatorId : null;
  }
  if (isNaN(parseInt(programId))) {
    qProgramId = parseInt(qProgramId);
    programId = !isNaN(qProgramId) ? qProgramId : null;
  }
  if (isNaN(parseInt(yearId))) {
    qYearId = parseInt(qYearId);
    yearId = !isNaN(qYearId) ? qYearId : null;
  }
  if (isNaN(parseInt(termId))) {
    qTermId = parseInt(qTermId);
    termId = !isNaN(qTermId) ? qTermId : null;
  }

  return {
    areaId,regionId,coordinatorId,programId,yearId,termId
  };
}


export {windowLocationToNavigationParameters, queryStringObjectFromWindowLocation};
